import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { FaClock } from "react-icons/fa";

import { useDaily } from "../../../ducks/daily";
import { UserDailyGame } from "@chesshotel/types";
import DisplayBoard from "../../../chessBoard/components/DisplayBoard";
import { useSettings } from "@/ducks/settings";

export default function CActive() {
  const { games } = useDaily();
  const { chessSet } = useSettings();
  const dailyGames: UserDailyGame[] = Object.values(games);

  const { t } = useTranslation("common");
  const router = useRouter();

  const myTurn = dailyGames.filter(
    (game) => game.turn && game.resultId == null
  );

  const oppTurn = dailyGames.filter(
    (game) => !game.turn && game.resultId == null
  );

  function continueUserDailyGame(id) {
    router.push(`/daily/game/${id}`);
  }

  function prefixInteger(num, length) {
    return (num / Math.pow(10, length)).toFixed(length).substr(2);
  }

  function timeRemaining(game) {
    if (!game.lastMoveTime) game.lastMoveTime = Date.now();
    const lastMoveTimeStamp = new Date(game.lastMoveTime).getTime();
    const time = Date.now() - lastMoveTimeStamp;
    const timeInMills = 1000 * 60 * 60 * 24 * game.turnLength;
    const timeUntilEndMills = timeInMills - time;

    const sec =
      timeUntilEndMills < 10000
        ? Math.floor(timeUntilEndMills / 1000)
        : Math.ceil(timeUntilEndMills / 1000);

    const daysRaw = prefixInteger(Math.floor(sec / 86400), 2);
    const days = parseInt(daysRaw);
    const hoursInSec = Math.floor(sec % 86400);
    const hoursRaw: any = Math.floor(hoursInSec / 3600);
    const hours = parseInt(hoursRaw);
    const minInSec = Math.floor(sec % 3600);
    const minutes = prefixInteger(Math.floor(minInSec / 60), 2);
    const seconds = prefixInteger(sec % 60, 2);

    // Refactor this some how?
    if (game.turn && days > 0) {
      return (
        <p>
          {days}d {hours}
          {"h"}
        </p>
      );
    } else if (game.turn && days === 0) {
      return (
        <p>
          {hours}
          {"h"} {minutes}
          {"m"}
        </p>
      );
    } else if (game.turn && hours > 0) {
      return (
        <p>
          {minutes}:{seconds}
        </p>
      );
    } else if (!game.turn) {
      return <p>{t("days", { count: game.turnLength })}</p>;
    } else {
      return <p>{t("Game over")}</p>;
    }
  }

  function renderMyTurn() {
    return myTurn.map((game: UserDailyGame) => {
      return (
        <div
          className="px-2 py-2 cursor-pointer hover:bg-altgray-100"
          onClick={() => continueUserDailyGame(game.id)}
          key={game.id}
        >
          <div className="flex justify-between py-1 text-xs font-semibold">
            <div className="flex items-center gap-1">
              <FaClock />
              <div>{timeRemaining(game)}</div>
            </div>
            <div>{game.opponent.username}</div>
          </div>
          <DisplayBoard
            // lastMove={game.moves && game.moves[game.moves.length - 1]}
            fen={game.fen}
            playingWhite={game.playingWhite}
            boardSize={172}
            chessSet={chessSet}
          />
          <div className="text-sm font-semibold text-center text-orange-400">
            {t("Your move")}
          </div>
        </div>
      );
    });
  }

  function renderOppTurn() {
    return oppTurn.map((game: UserDailyGame) => {
      return (
        <div
          className="flex flex-col px-2 py-2 cursor-pointer hover:bg-altgray-100"
          onClick={() => continueUserDailyGame(game.id)}
          key={game.id}
        >
          <div className="flex justify-between py-1 text-xs font-semibold">
            <div className="flex items-center gap-1">
              <FaClock />
              <div>{timeRemaining(game)}</div>
            </div>
            <div>{game.opponent.username}</div>
          </div>
          <DisplayBoard
            // lastMove={game.moves && game.moves[game.moves.length - 1]}
            fen={game.fen}
            playingWhite={game.playingWhite}
            boardSize={172}
            chessSet={chessSet}
          />
          <div className="text-sm font-semibold text-center"></div>
        </div>
      );
    });
  }

  // function renderFinishedGames() {
  //   return finished.map((game) => {
  //     return (
  //       <tr onClick={() => continueUserDailyGame(game.id)} key={game.id}>
  //         <td>{game.opponent.username}</td>
  //         <td>{game.opponent.elo}</td>
  //         <td>{t("Finished")}</td>
  //         <td>
  //           {game.variantId == 1 ? (
  //             <div className="flex items-center">
  //               <div className="mr-1">
  //                 <FaPaperPlane />
  //               </div>
  //               {t("Standard")}
  //             </div>
  //           ) : (
  //             <div className="flex items-center">
  //               <div className="mr-1">
  //                 <FaDiceSix />
  //               </div>
  //               960
  //             </div>
  //           )}
  //         </td>
  //       </tr>
  //     );
  //   });
  // }

  return (
    <div
      className={`relative w-full h-full bg-white rounded-md  rounded-b-lg overflow-hidden`}
    >
      <div className="flex flex-wrap w-full bg-white ">
        {renderMyTurn()}
        {renderOppTurn()}
      </div>
    </div>
  );
}
